module.exports = __webpack_public_path__ + "static/media/Gar-A-MondTall.21f120c9.ttf";